/**
 * "Summary" card. Renders one refund breakdown per draft that has selected items, each titled
 * "RMA with Fulfillment i" for a mixed order, plus the single page-level internal note.
 */
import {observer} from "mobx-react";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../components/fonts/font-body2/font-body2";
import FontHeading2 from "../../../components/fonts/font-heading2/font-heading2";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import Card from "../../../components/layouts/card/card";
import './summary-card.scss';
import ListLayout from "../../../components/layouts/list-layout/list-layout";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import type { CreateRmaMainStore } from '../stores/create-rma-main-store';
import SummaryNote from "./summary-note";
import SummarySection from "./summary-section";

interface IProps {
	createRmaMainStore: CreateRmaMainStore;
}

const SummaryCard: React.FC<IProps> = observer(({ createRmaMainStore }) => {

    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';
    const { isMixedOrder, draftsWithSelectedItems, session: sessionStore } = createRmaMainStore;

	if (draftsWithSelectedItems.length === 0) {
		return <></>;
	}

	return (
		<div className={'createrma-summary-card'}>
			<ListLayout>
				<FontHeading2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>{getTranslation('SUMMARY', pageScope)}</FontHeading2>
				{isMixedOrder &&
					<FontBody2 color={FONT_COLOR.PRIMARY3}>{getTranslation('SUMMARY_PER_FULFILLMENT_DESCRIPTION', pageScope)}</FontBody2>
				}
				<Card>
					{draftsWithSelectedItems.map((draft) => (
						<div className={'summary-rma-block'} key={draft.orderStore.orderId}>
							{isMixedOrder &&
								<FontBody1 color={FONT_COLOR.ACCENT1} variant={FONT_VARIANT.BOLD}>
									{getTranslation('RMA_WITH_FULFILLMENT', pageScope, [String(draft.index)])}
								</FontBody1>
							}
							<SummarySection rmaRequestStore={draft.requestStore} />
						</div>
					))}
					{sessionStore && <SummaryNote sessionStore={sessionStore} />}
				</Card>
			</ListLayout>
		</div>
	)
});

export default SummaryCard;
